import { z } from 'zod';
import { SESSION_PLANS } from './session.js';
/**
 * The operator-facing contract. `ops` is instance-wide (whoever runs the server);
 * `admin` is per-session (whoever is hosting one event). Keeping the two words
 * apart matters - an ops token can reach every session on the box.
 */
export const opsLoginSchema = z.object({
    passphrase: z.string().min(1),
});
/** How far out an expiry may be moved, either direction, from now. */
export const MAX_EXPIRY_SHIFT_DAYS = 365;
export const opsExpirySchema = z.object({
    expiresAt: z.number().int().positive(),
});
/**
 * An operator moving a wall onto a plan by hand - a comp, or putting right a
 * payment that went astray. Every plan is allowed here, including back down to
 * `unpaid`, because undoing a mistaken upgrade is as necessary as making one.
 */
export const opsSetPlanSchema = z.object({ plan: z.enum(SESSION_PLANS) });
//# sourceMappingURL=ops.js.map